import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from "@formio/react";
import { useLocation } from "wouter";
export const EnterData = ({ url }) => {
    const setLocation = useLocation()[1];
    return (_jsx("div", { className: "panel enter-data active", children: _jsx(Form, { src: url, onSubmitDone: () => setLocation("/view") }) }));
};
